import { h } from "hyperapp";

import paginationCSS from "./pagination.css";

export const pagination = ({
  actions: { onChange, setPagination },
  section,
  state: {
    currentPageNumber,
    disabled,
    pageCount,
    pageNumber,
    pageNumberInvalid,
    pageSize,
  },
}) => {
  return (
    <form
      class={paginationCSS.main}
      novalidate
      onsubmit={event => event.preventDefault()}
    >
      <div className="d-flex">
        <div class="mr-2">
          <label class="sr-only" for="showThisManyResults">
            Resultados por página
          </label>
          <select
            class="custom-select"
            disabled={disabled}
            id="showThisManyResults"
            onclick={event => (
              event.preventDefault(),
              setPagination({
                onChange,
                pageSize: event.target.value,
                section,
                pageNumber: currentPageNumber,
              })
            )}
          >
            <option selected={String(pageSize) === "25"} value="25">
              25
            </option>
            <option selected={String(pageSize) === "50"} value="50">
              50
            </option>
            <option selected={String(pageSize) === "75"} value="75">
              75
            </option>
            <option selected={String(pageSize) === "100"} value="100">
              100
            </option>
          </select>
        </div>
        <nav aria-label="Pagination" style="height:38px;">
          <ul class="pagination">
            {disabled || currentPageNumber === 0 || pageNumber < 2 ? (
              <li class="disabled page-item">
                <span class="page-link">&laquo;</span>
              </li>
            ) : (
              <li class="page-item">
                <a
                  class="page-link"
                  href="#"
                  onclick={() => (
                    event.preventDefault(),
                    setPagination({
                      onChange,
                      pageNumber: 1,
                      section,
                    })
                  )}
                >
                  &laquo;
                </a>
              </li>
            )}
            {disabled || currentPageNumber === 0 || pageNumber < 2 ? (
              <li class="disabled page-item">
                <span class="page-link">&lsaquo;</span>
              </li>
            ) : (
              <li class="page-item">
                <a
                  class="page-link"
                  href="#"
                  onclick={() => (
                    event.preventDefault(),
                    setPagination({
                      onChange,
                      pageNumber: pageNumber - 1,
                      section,
                    })
                  )}
                >
                  &lsaquo;
                </a>
              </li>
            )}
            <li class="page-item">
              <span class="page-link">
                <label class="sr-only" for="showThisPage">
                  Página atual
                </label>
                <input
                  class={`${paginationCSS.pageNumber}${
                    pageNumberInvalid
                      ? " " + paginationCSS.pageNumberInvalid
                      : ""
                  }`}
                  disabled={disabled || currentPageNumber === 0}
                  id="showThisPage"
                  max={pageCount}
                  min="1"
                  onkeyup={event =>
                    event.key === "Enter" &&
                    setPagination({
                      onChange,
                      pageNumber: event.target.value,
                      section,
                      target: event.target,
                    })
                  }
                  onfocus={event => event.target.select()}
                  required
                  type="number"
                  value={currentPageNumber}
                />
              </span>
            </li>
            {disabled || currentPageNumber === 0 || pageNumber >= pageCount ? (
              <li class="disabled page-item">
                <span class="page-link">&rsaquo;</span>
              </li>
            ) : (
              <li class="page-item">
                <a
                  class="page-link"
                  href="#"
                  onclick={() => (
                    event.preventDefault(),
                    setPagination({
                      onChange,
                      pageNumber: pageNumber + 1,
                      section,
                    })
                  )}
                >
                  &rsaquo;
                </a>
              </li>
            )}
            {disabled || currentPageNumber === 0 || pageNumber >= pageCount ? (
              <li class="disabled page-item">
                <span class="page-link">&raquo;</span>
              </li>
            ) : (
              <li class="page-item">
                <a
                  class="page-link"
                  href="#"
                  onclick={event => (
                    event.preventDefault(),
                    setPagination({
                      onChange,
                      pageNumber: pageCount,
                      section,
                    })
                  )}
                >
                  &raquo;
                </a>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </form>
  );
};
